// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-data-analyst",
 "roleDisplay": "AI Data Analyst",
 "phrase": "ai data analyst",
 "seo": {
  "title": "AI Data Analyst: Queries, Dashboards, Answers | CellCog",
  "description": "An AI data analyst that connects to your database and spreadsheets, writes their own queries, builds live dashboards and explains what changed and why."
 },
 "painSub": "The data is there. The answer takes a week because someone has to write the query, clean the export and build the chart. Your AI data analyst does all three and tells you what the numbers mean.",
 "definition": "An AI data analyst is an AI employee that connects to your databases and spreadsheets, writes and runs their own queries, builds live dashboards and explains what changed in your numbers. On CellCog they are hired in minutes, work read-only by default, and dig into causes with the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · DASHBOARD",
   "title": "Builds the dashboard.",
   "sub": "A live dashboard from your own data, refreshed on the schedule you set.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--chart\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Dashboard</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Pallet Street orders</b><span>Shopify and Google Analytics, refreshed 6:00 am</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>612</b><span>orders this week</span><em class=\"rf-delta\">+3.7% vs last week</em></div><div class=\"rf-stat\"><b>38%</b><span>repeat customers</span><em class=\"rf-delta\">+4 pts in 4 weeks</em></div><div class=\"rf-stat\"><b>3.1%</b><span>return rate</span><em class=\"rf-delta\">down 0.6 pts</em></div></div><div class=\"rf-panel rf-chart\"><div class=\"rf-ch-h\"><span class=\"rf-ch-t\">Weekly orders, last 12 weeks</span><span class=\"rf-legend\"><span class=\"rf-leg rf-tone-accent\"><i></i>Orders</span></span></div><div class=\"rf-line rf-tone-accent\"><svg viewBox=\"0 0 100 40\" preserveAspectRatio=\"none\" aria-hidden=\"true\"><polygon points=\"0,40 0.0,37.0 9.09,33.51 18.18,29.87 27.27,32.09 36.36,27.5 45.45,23.06 54.55,20.84 63.64,21.95 72.73,16.41 81.82,12.29 90.91,8.49 100.0,5.0 100,40\" fill=\"currentColor\" opacity=\".12\"/><polyline points=\"0.0,37.0 9.09,33.51 18.18,29.87 27.27,32.09 36.36,27.5 45.45,23.06 54.55,20.84 63.64,21.95 72.73,16.41 81.82,12.29 90.91,8.49 100.0,5.0\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" vector-effect=\"non-scaling-stroke\" stroke-linejoin=\"round\"/></svg><span class=\"rf-sr\">W1: 410. W2: 432. W3: 455. W4: 441. W5: 470. W6: 498. W7: 512. W8: 505. W9: 540. W10: 566. W11: 590. W12: 612. </span></div><div class=\"rf-xlabs\"><span>W1</span><span>W2</span><span>W3</span><span>W4</span><span>W5</span><span>W6</span><span>W7</span><span>W8</span><span>W9</span><span>W10</span><span>W11</span><span>W12</span></div></div></div></div></div>"
  },
  {
   "num": "02 · FINDINGS",
   "title": "Finds what changed.",
   "sub": "Segments and cohorts side by side, with the query behind every number.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--table\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Findings</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>This week&#x27;s findings</b><span>6 findings, each with its evidence</span></div><div class=\"rf-panel\"><table class=\"rf-table\"><thead><tr><th scope=\"col\">Finding</th><th scope=\"col\">Evidence</th><th scope=\"col\">Suggested next step</th></tr></thead><tbody><tr><td data-label=\"Finding\">Rain jackets sell out on Thursdays</td><td data-label=\"Evidence\">9 of the last 10 weeks</td><td data-label=\"Suggested next step\">Restock on Tuesdays</td></tr><tr><td data-label=\"Finding\">Free-shipping line lifts baskets</td><td data-label=\"Evidence\">+11% basket size near the line</td><td data-label=\"Suggested next step\">Test raising the line</td></tr><tr><td data-label=\"Finding\">Boot returns cluster on one size</td><td data-label=\"Evidence\">42% of boot returns are size 9</td><td data-label=\"Suggested next step\">Add a fit note to the page</td></tr><tr><td data-label=\"Finding\">Email brings back repeat buyers</td><td data-label=\"Evidence\">3.2x repeat orders vs social</td><td data-label=\"Suggested next step\">Move spend to email</td></tr><tr><td data-label=\"Finding\">Checkout drops at the shipping step</td><td data-label=\"Evidence\">18% leave before paying</td><td data-label=\"Suggested next step\">Show shipping cost earlier</td></tr><tr><td data-label=\"Finding\">Gift cards spike before holidays</td><td data-label=\"Evidence\">2.4x sales in the last two weeks of 2025</td><td data-label=\"Suggested next step\">Promote gift cards early</td></tr></tbody></table><ul class=\"rf-tlist\"><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Rain jackets sell out on Thursdays</b></div><span class=\"rf-tl-rest\">9 of the last 10 weeks · Restock on Tuesdays</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Free-shipping line lifts baskets</b></div><span class=\"rf-tl-rest\">+11% basket size near the line · Test raising the line</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Boot returns cluster on one size</b></div><span class=\"rf-tl-rest\">42% of boot returns are size 9 · Add a fit note to the page</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Email brings back repeat buyers</b></div><span class=\"rf-tl-rest\">3.2x repeat orders vs social · Move spend to email</span></li></ul><div class=\"rf-tlist-more\"><p class=\"rf-sched-more\">and 2 more</p></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers your metrics.",
   "sub": "Metric definitions, past reports and data notes live in your Drive, so every number means the same thing.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Pallet Street</span><i aria-hidden=\"true\">/</i><b>Analytics</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Orders export, Sep.xlsx</span><span class=\"rf-fmeta\">18,240 rows</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Metric definitions.docx</span><span class=\"rf-fmeta\">What counts as a repeat buyer</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Q3 board summary.pdf</span><span class=\"rf-fmeta\">Last quarter&#x27;s numbers</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Weekly reports</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Revenue excludes refunds, weeks start on Monday, and anything under 50 orders is too small to call.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before touching data.",
   "sub": "They read by default. Anything that would change a record waits for your yes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Share this finding in #ops on Slack?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/slack.svg\" alt=\"\" width=\"16\" height=\"16\"><span>Slack</span><em>#ops</em></div><b class=\"rf-prev-t\">Boot returns cluster on size 9</b><p class=\"rf-prev-b\">42% of boot returns this quarter are size 9, most noting &#x27;runs small&#x27;. Suggest a fit note on the product page. Chart attached.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Weekly dashboard email to the team</span><span class=\"rf-q-m\">Gmail · Mon 7:00</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Ask Shopify support about the missing tax field</span><span class=\"rf-q-m\">Gmail · drafted</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Explains the week.",
   "sub": "A short note in plain words: what moved, why it moved and what to look at next.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Pallet Street numbers</b><span>Today, 6:10 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>612</b><span>orders this week</span></div><div class=\"rf-stat\"><b>5</b><span>findings</span></div><div class=\"rf-stat\"><b>2</b><span>dashboards refreshed</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Refreshed the orders and returns dashboards</li><li>Found 5 patterns, each with its evidence</li><li>Checked the totals against Shopify</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Test the free-shipping line with a small group</li><li>Break down returns by product page</li><li>Draft the October summary</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Pick which finding to act on first</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Queries your data",
   "body": "Connects to your database, spreadsheets and analytics, then writes and runs the queries."
  },
  {
   "title": "Builds live dashboards",
   "body": "Interactive dashboards your team can open any time, refreshed on a schedule."
  },
  {
   "title": "Finds the story",
   "body": "Segments, cohorts and comparisons that explain what changed and why it matters."
  },
  {
   "title": "Forecasts in a spreadsheet",
   "body": "Projections with real formulas and assumptions you can adjust yourself."
  },
  {
   "title": "Watches your metrics",
   "body": "Notices a meaningful move and tells you before it turns into a surprise."
  },
  {
   "title": "Shows their work",
   "body": "Every chart comes with the query behind it, so anyone can rerun and check it."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a data analyst. Tell me which customer segments grew last quarter and why.\""
  },
  {
   "n": "02",
   "title": "Connect your data.",
   "body": "Add a database with read-only credentials, your spreadsheets or Google Analytics."
  },
  {
   "n": "03",
   "title": "Review the first answer.",
   "body": "They send the finding, the chart and the query. Ask a follow-up in one message."
  }
 ],
 "tools": [
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  },
  {
   "name": "Google Analytics",
   "logo": "https://logos.composio.dev/api/google_analytics"
  },
  {
   "name": "BigQuery",
   "logo": "https://logos.composio.dev/api/googlebigquery"
  },
  {
   "name": "Stripe",
   "logo": "https://logos.composio.dev/api/stripe"
  },
  {
   "name": "HubSpot",
   "logo": "https://logos.composio.dev/api/hubspot"
  },
  {
   "name": "Airtable",
   "logo": "https://logos.composio.dev/api/airtable"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  }
 ],
 "control": {
  "statement": "Nothing changes without your yes.",
  "sub": "They read and explain.",
  "accent": "You decide what changes.",
  "rows": [
   {
    "title": "Read-only by default",
    "body": "They query and report; writing to your data needs your explicit approval."
   },
   {
    "title": "You choose what they can reach",
    "body": "Connect one spreadsheet or a whole warehouse, and disconnect any time."
   },
   {
    "title": "Every query on record",
    "body": "The query behind each number sits beside the chart."
   }
  ]
 },
 "wont": {
  "sub": "They analyze your data.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No writes to your data",
    "body": "They read; changing records needs your explicit approval."
   },
   {
    "title": "No data they can't reach",
    "body": "Knowledge that lives in someone's head stays out until it is written down."
   },
   {
    "title": "No silent guesses",
    "body": "When a number looks like a data glitch, they say so instead of explaining it away."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to answer a data question",
  "cols": [
   "Doing it yourself",
   "A BI tool",
   "AI Data Analyst"
  ],
  "rows": [
   {
    "label": "Writes the query",
    "cells": [
     "You",
     "An analyst models it first",
     "Yes, and shows it"
    ]
   },
   {
    "label": "Builds the chart",
    "cells": [
     "You",
     "Yes, once modeled",
     "Yes"
    ]
   },
   {
    "label": "Explains what changed",
    "cells": [
     "You",
     "No",
     "In plain words"
    ]
   },
   {
    "label": "Refreshes on a schedule",
    "cells": [
     "You remember",
     "Yes",
     "Yes, with a note"
    ]
   },
   {
    "label": "Flags likely data glitches",
    "cells": [
     "When you notice",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Works read-only by default",
    "cells": [
     "n/a",
     "Depends on setup",
     "Yes"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Connect to our database and tell me: which customer segments grew last quarter, which shrank, and what changed. Build a dashboard I can check every week.",
   "deliverable": "a segment analysis plus a live dashboard"
  },
  {
   "q": "Here is a CSV of 12 months of sales. Find seasonality, our top products by margin, and three things we should do differently.",
   "deliverable": "an analysis report with recommendations"
  },
  {
   "q": "Our churn ticked up in May. Dig into the data and tell me which cohorts are churning, when in their lifecycle, and any common patterns.",
   "deliverable": "a churn investigation with cohort breakdowns"
  },
  {
   "q": "Build a financial model in a spreadsheet: revenue projection for the next 6 months based on our actuals, with assumptions I can adjust.",
   "deliverable": "a spreadsheet model with live formulas"
  },
  {
   "q": "Every Monday, refresh our KPI dashboard from the database and email me a summary of what moved and why.",
   "deliverable": "a weekly dashboard refresh with a summary"
  }
 ],
 "faq": [
  {
   "q": "What is an AI data analyst?",
   "a": "An AI data analyst is an AI employee that connects to your databases and spreadsheets, writes and runs their own queries, builds live dashboards and explains what changed in your numbers."
  },
  {
   "q": "Can they connect to our database?",
   "a": "Yes, with credentials you control. Read-only access is the sensible default. They work with databases like PostgreSQL and MongoDB, spreadsheets, CSV exports and Google Analytics."
  },
  {
   "q": "How do I check their analysis?",
   "a": "Every answer comes with the query they ran and the numbers behind the chart, so anyone on your team can rerun it. Ask your AI data analyst to show their work and they will."
  },
  {
   "q": "Can they build dashboards the team uses?",
   "a": "Yes. They build interactive dashboards and refresh them on the schedule you set, then send a short note on what moved."
  },
  {
   "q": "How is this different from Looker or Tableau?",
   "a": "Those tools show data after someone models it and builds the views. Your AI data analyst does the modeling and the views, then explains the result in plain language."
  },
  {
   "q": "What kind of AI data analysis can they do?",
   "a": "Cohorts, churn, seasonality, funnel drop-off, forecasts in a spreadsheet with real formulas, and the question behind all of them: what changed, and why."
  },
  {
   "q": "Can I use data analyst AI without a database?",
   "a": "Yes. Upload a CSV or share a spreadsheet and they work from there. Connect a database later when you want live dashboards."
  },
  {
   "q": "Is an AI data analyst a good fit for a small business?",
   "a": "Yes. They suit teams with data spread across a few tools and nobody with time to read it. Your AI data analyst pulls the numbers together, explains what changed and keeps a dashboard current."
  },
  {
   "q": "Can I try an AI data analyst for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI data analyst and try a first task."
  },
  {
   "q": "What does an AI data analyst cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Data Analyst in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Data Analyst to work today",
  "body": "Point them at last quarter's data and get back the analysis, the dashboard, and the three decisions hiding in your numbers."
 },
 "audience": {
  "title": "Who hires an AI data analyst",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Numbers with the so-what attached",
    "body": "No more exporting spreadsheets at midnight: the weekly numbers arrive analyzed, with what changed and why."
   },
   {
    "badge": "Small businesses",
    "title": "Numbers in plain words",
    "body": "Sales, spending and customers pulled from your spreadsheets and tools, with what changed each week explained."
   },
   {
    "badge": "Mid-size companies",
    "title": "A dashboard for each team",
    "body": "Live dashboards built from your database, read-only by default, with weekly summaries for the people who need them."
   },
   {
    "badge": "Agencies",
    "title": "Reports for every client",
    "body": "Data-backed client reports on schedule, each built from that client's own accounts."
   },
   {
    "badge": "Online stores",
    "title": "Sales by product and channel",
    "body": "Margins, best sellers and repeat buyers from your store and ad data, with what to change next."
   },
   {
    "badge": "Software companies",
    "title": "Churn and growth explained",
    "body": "Signups, churn and revenue cohorts read from your database, with the patterns behind each change."
   }
  ]
 }
};

export default content;
